import { IDictionary } from 'types';

export const AUTO_COLUMN_KEY = 'ag-Grid-AutoColumn';
export const GROUP_ID_KEY = 'path';
export const CHILDREN_KEY = 'spendItems';
export const RULE_KEY = 'rule';
export const RULE_ID = 'ruleId';

export const RULE_COLUMNS = {
  apSpendCategoryL1: 'apSpendCategoryL1',
  apSpendCategoryL2: 'apSpendCategoryL2',
  categoryL1Code: 'categoryL1Code',
  categoryL2Code: 'categoryL2Code',
  id: 'id',
};

export const CONDITIONS = {
  equals: '',
  notEqual: 'not',
  notContains: 'not_contains',
  contains: 'contains',
  endsWith: 'ends_with',
  in: 'in',
  inRange: 'in',
  notEndsWith: 'not_ends_with',
  notIn: 'not_in',
  notStartsWith: 'not_starts_with',
  startsWith: 'starts_with',
  greaterThanOrEqual: 'gte',
  greaterThan: 'gt',
  lessThan: 'lt',
  lessThanOrEqual: 'lte',
  some: 'some',
} as IDictionary;
